/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Realitni_KomoraInputs */

const cs_enum_realitni_komora = /** @type {(inputs: Enum_Realitni_KomoraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní komora`)
};

const en_enum_realitni_komora = /** @type {(inputs: Enum_Realitni_KomoraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitni komora`)
};

/**
* | output |
* | --- |
* | "Realitni komora" |
*
* @param {Enum_Realitni_KomoraInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitni_komora = /** @type {((inputs?: Enum_Realitni_KomoraInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Realitni_KomoraInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitni_komora(inputs)
	return cs_enum_realitni_komora(inputs)
});